import configSingletonInstance from 'src/ConfigSingleton';

const envConfig = configSingletonInstance.getConfig();

function track(...args) {
  if (envConfig.USE_GA === 'NO') {
    return;
  }

  if (!window.gtag) {
    return;
  }

  window.gtag(...args);
}

function pageview(props) {
  track('config', process.env.GA_MEASUREMENT_ID_FOR_CONVERSION, props);
}

function event(type, props) {
  track('event', type, props);
}

export default {
  pageview,
  event
};
